import React from 'react';
import { Box, Container, Link, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import { Header } from '@bizapp-lp/pjr/organisms/Header';
import { Footer } from '@bizapp-lp/pjr/organisms/Footer';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: '523px',
    },
    headerArea: {
      padding: theme.spacing(5, 2),
      backgroundColor: '#f2f3fb',
      '& .MuiTypography-h1': {
        fontSize: '32px',
        fontWeight: 'bold',
        textAlign: 'center',
        [theme.breakpoints.down(768)]: {
          fontSize: '24px',
        },
      },
    },
    contents: {
      margin: theme.spacing(5, 'auto', 8),
      padding: theme.spacing(0, 2),
      textAlign: 'center',
      '& .MuiTypography-h2': {
        color: theme.palette.themeColor.main,
        fontSize: '28px',
        fontWeight: 'bold',
        textAlign: 'center',
        [theme.breakpoints.down(768)]: {
          fontSize: '20px',
          lineHeight: '36px',
        },
      },
      '& .MuiTypography-body1': {
        fontSize: '14px',
        margin: '24px auto 40px',
        '& span': { display: 'block' },
      },
    },
    link: {
      color: '#1565C0',
      fontSize: '14px',
      fontWeight: 'normal',
    },
  }),
);

export interface CompleteProps {
  className?: string;
  heading1?: React.ReactNode;
  heading2?: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
}

const Component: React.FC<CompleteProps> = ({
  className = '',
  heading1,
  heading2,
  description,
  children,
}: CompleteProps) => {
  const classes = useStyles();

  return (
    <>
      <Header />
      <Box component="section" className={`${classes.root} ${className}`}>
        <Container
          disableGutters
          maxWidth={false}
          className={classes.headerArea}
        >
          <Typography variant="h1">{heading1}</Typography>
        </Container>
        <Container disableGutters maxWidth={false} className={classes.contents}>
          <Typography variant="h2">{heading2}</Typography>
          <Typography>{description}</Typography>
          {children}
          <Link
            className={classes.link}
            href="https://www.worksap.co.jp/saas/projectroom/"
          >
            TOPページへ戻る
          </Link>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export const Complete = React.memo(Component);
